import React, { useState, useEffect } from "react";
import { FaVolumeMute, FaVolumeUp, FaAngleDown } from "react-icons/fa";
import { Hero } from "../../Assests/Assests";
import "./HeroPage.css";
import { HeroBG } from "../../Assests/Assests";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast,} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HeroPage = () => {
  // const videoUrl = HeroBG;
  // const imageUrl = Hero;

  const [navItems, setNavItems] = useState([
    { title: "All Products", path: "/newproduct" },
    { title: "Spectacle", path: "/products-collection" },
    // { title: "Account", path: "/newuserprofile" },
    // { title: "Contact" },
    { title: "About", path: "/about" },
  ]);

  const [categories, setCategories] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMuted, setIsMuted] = useState(true);
  const [displayType, setDisplayType] = useState("video");
  const [activeMediaUrl, setActiveMediaUrl] = useState(null);
  const [error, setError] = useState("");
  // const [loading, setLoading] = useState(false); // Loader state
  const [fileType, setfileType] = useState("");

  const navigate = useNavigate();

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          "https://admin.riymay.com/api/v1/admin/get/all/main/product-categories"
        );
        if (!response.ok) throw new Error("Failed to fetch categories");
        const data = await response.json();
        setCategories(data.response);
      } catch (err) {
        console.error(err);
        setError(err.message);
      }
    };

    fetchCategories();
  }, []);

  // Fetch Hero Section Media
  useEffect(() => {
    const fetchHeroSectionMedia = async () => {
      try {
        const response = await fetch(
          "https://admin.riymay.com/api/v1/admin/hero-section/media"
        );
        const data = await response.json();

        if (data.message === "success") {
          const activeMedia = data.heroSectionMedia.find(
            (media) => media.activeStatus === "active"
          );
          setfileType(activeMedia.fileType);
          if (activeMedia) {
            setActiveMediaUrl(activeMedia.url);
          } else {
            console.warn("No active media found");
          }
        } else {
          console.error("Failed to fetch media:", data.message);
        }
      } catch (error) {
        console.error("Error fetching hero section media:", error);
      }
    };

    fetchHeroSectionMedia();
  }, []);

  const toggleDropdown = (title) => {
    setOpenDropdown(openDropdown === title ? null : title);
  };

  const toggleMute = () => setIsMuted(!isMuted);

  const toggleDisplayType = () =>
    setDisplayType(displayType === "video" ? "image" : "video");

  const handleCategoryClick = (categoryName) => {
    navigate("/newproduct", { state: { category: categoryName } });
  };

  const location = useLocation(); // Detects route changes
  const toastId = "welcome-toast"; // Unique toast ID

  useEffect(() => {
    // Prevent duplicate toasts by checking if the toast is already active
    if (!toast.isActive(toastId)) {
      toast(
        <div className="riymay-toast-inner">
          <span className="riymay-toast-tag">TRY &amp; BUY</span>
          <p className="riymay-toast-text">
            Order, try at home, and only pay for what you keep.
          </p>
        </div>,
        {
          toastId,
          position: "bottom-right",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          className: "riymay-toast",
          bodyClassName: "riymay-toast-body",
        }
      );
    }

    // Cleanup function to dismiss toast when page changes
    return () => {
      toast.dismiss(toastId);
    };
  }, [location]); // Runs when the route changes

  return (
    <div className="hero-page">
      {/* <ToastContainer style={{ zIndex: 9999999 }}/> */}

      {/* Display Type Toggle Button */}
      {/* <button className="toggle-display-type" onClick={toggleDisplayType}>
        Switch to {displayType === "video" ? "Image" : "Video"}
      </button> */}

      {/* Background Content */}
      {fileType && fileType == "image" ? (
        <>
          <img
            className="background-image"
            src={`https://riymay.com/assets/${activeMediaUrl}`}
            alt="Hero Background"
          />
          <div className="overlay"></div>
        </>
      ) : (
        <>
          <video
            className="background-video"
            src={`https://riymay.com/assets/${activeMediaUrl}`}
            // src="https://videos.pexels.com/video-files/853800/853800-hd_1920_1080_25fps.mp4"
            autoPlay
            muted={isMuted}
            loop
            playsInline
            disablePictureInPicture
            controls={false}
            onContextMenu={(e) => e.preventDefault()}
            onClick={(e) => e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
          ></video>
          <div className="overlay"></div>
        </>
      )}

      {/* Navigation */}
      {/* <nav className="nav">
        <div className="nav-item">
          <div
            className="nav-title"
            onClick={() => toggleDropdown("Collections")}
          >
            Collections
            <FaAngleDown
              className={`dropdown-icon ${
                openDropdown === "Collections" ? "open" : ""
              }`}
            />
          </div>
          {openDropdown === "Collections" && (
            <div className="dropdown-nav">
              {categories.length > 0 ? (
                categories.map((category, index) => (
                  <div key={index} className="dropdown-nav-item" onClick={() => handleCategoryClick(category.name)}>
                    {category.name}
                  </div>
                ))
              ) : (
                <div className="dropdown-nav-item">Loading...</div>
              )}
            </div>
          )}
        </div>

        {navItems.map((item, index) => (
          <div key={index} className="nav-item" >
            <div
              className="nav-title"
              onClick={() =>
                item.dropdowns ? toggleDropdown(item.title) : null
              }
            >
              {item.path ? (
                <Link to={item.path}>{item.title}</Link>
              ) : (
                item.title
              )}
              {item.dropdowns && (
                <FaAngleDown
                  className={`dropdown-icon ${
                    openDropdown === item.title ? "open" : ""
                  }`}
                />
              )}
            </div>
            {openDropdown === item.title && item.dropdowns && (
              <div className="dropdown-nav">
                {item.dropdowns.map((dropdownItem, idx) => (
                  <div key={idx} className="dropdown-nav-item">
                    {dropdownItem}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav> */}
      <nav className="nav">
        <div className="nav-item" style={{ "--order": 0 }}>
          <div
            className="nav-title"
            onClick={() => toggleDropdown("Collections")}
          >
            Collections
            <FaAngleDown
              className={`dropdown-icon ${
                openDropdown === "Collections" ? "open" : ""
              }`}
            />
          </div>
          {openDropdown === "Collections" && (
            <div className="dropdown-nav animated-dropdown">
              {categories.length > 0 ? (
                categories.map((category, index) => (
                  <div
                    key={index}
                    className="dropdown-nav-item"
                    onClick={() => handleCategoryClick(category.name)}
                    style={{ "--order": index }}
                  >
                    {category.name}
                  </div>
                ))
              ) : (
                <div className="dropdown-nav-item">Loading...</div>
              )}
            </div>
          )}
        </div>

        {navItems.map((item, index) => (
          <div
            key={index}
            className="nav-item animated-item"
            style={{ "--order": index + 1 }}
          >
            <div
              className="nav-title"
              onClick={() =>
                item.dropdowns ? toggleDropdown(item.title) : null
              }
            >
              {item.path ? (
                <Link to={item.path}>{item.title}</Link>
              ) : (
                item.title
              )}
              {item.dropdowns && (
                <FaAngleDown
                  className={`dropdown-icon ${
                    openDropdown === item.title ? "open" : ""
                  }`}
                />
              )}
            </div>
            {openDropdown === item.title && item.dropdowns && (
              <div className="dropdown-nav animated-dropdown">
                {item.dropdowns.map((dropdownItem, idx) => (
                  <div
                    key={idx}
                    className="dropdown-nav-item"
                    style={{ "--order": idx }}
                  >
                    {dropdownItem}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* Mute Button */}
      <div className="video-mute-button" onClick={toggleMute}>
        <span>
          {" "}
          {isMuted ? <FaVolumeMute size={20} /> : <FaVolumeUp size={20} />}
        </span>
      </div>
    </div>
  );
};

export default HeroPage;
